module.exports = __webpack_public_path__ + "static/media/Maax-Bold.0a665d07.eot";